module.exports = __webpack_public_path__ + "img/control_de_calidad2_4-3_1536.2cc4982e.webp";